import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Public Page Components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PropertyPage from './pages/PropertyPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import ApartmentPage from './pages/ApartmentPage';
import ApartmentDetailPage from './pages/ApartmentDetailPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import HowItWorksPage from './pages/HowItWorksPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import TeamPage from './pages/TeamPage';
import LoginPage from './pages/Login';
import Register from './pages/Register';
import RequestViewingPage from './pages/RequestViewingPage';
import GalleryPage from './pages/GalleryPage';

// Dashboard Components
import Dashboard from './pages/dashboard/Dashboard';
import PropertiesManagement from './pages/dashboard/PropertiesManagement';
import PropertyForm from './pages/dashboard/PropertyForm';
import BlogsManagement from './pages/dashboard/BlogsManagement';
import BlogForm from './pages/dashboard/BlogForm';
import HeroSlidesManagement from './pages/dashboard/HeroSlidesManagement';
import ContactInquiries from './pages/dashboard/ContactInquiries';
import GalleryManagement from './pages/dashboard/GalleryManagement';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <DataProvider>
              <AppContent />
            </DataProvider>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const showNav = !location.pathname.startsWith('/dashboard') && location.pathname !== '/login' && location.pathname !== '/register';
  const showFooter = !location.pathname.startsWith('/dashboard') && location.pathname !== '/login' && location.pathname !== '/register';

  return (
    <>
      {showNav && <Navigation />}
      <Routes>
        {/* Auth Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />

        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/request-viewing" element={<RequestViewingPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        
        {/* Properties/Apartments Routes */}
        <Route path="/property" element={<ApartmentPage />} />
        <Route path="/properties" element={<ApartmentPage />} />
        <Route path="/property/:id" element={<PropertyDetailPage />} />
        <Route path="/apartment" element={<ApartmentPage />} />
        <Route path="/apartment/:id" element={<PropertyDetailPage />} />
        
        {/* Blog Routes */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetailPage />} />
        
        {/* Dashboard Routes */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/dashboard/properties" element={<ProtectedRoute><PropertiesManagement /></ProtectedRoute>} />
        <Route path="/dashboard/properties/create" element={<ProtectedRoute><PropertyForm /></ProtectedRoute>} />
        <Route path="/dashboard/properties/:id/edit" element={<ProtectedRoute><PropertyForm /></ProtectedRoute>} />
        <Route path="/dashboard/blogs" element={<ProtectedRoute><BlogsManagement /></ProtectedRoute>} />
        <Route path="/dashboard/blogs/create" element={<ProtectedRoute><BlogForm /></ProtectedRoute>} />
        <Route path="/dashboard/blogs/:id/edit" element={<ProtectedRoute><BlogForm /></ProtectedRoute>} />
        <Route path="/dashboard/hero-slides" element={<ProtectedRoute><HeroSlidesManagement /></ProtectedRoute>} />
        <Route path="/dashboard/gallery" element={<ProtectedRoute><GalleryManagement /></ProtectedRoute>} />
        <Route path="/dashboard/inquiries" element={<ProtectedRoute><ContactInquiries /></ProtectedRoute>} />
      </Routes>
      {showFooter && <Footer />}
    </>
  );
}

export default App;
